export const downloadFile = (
  blobData: Blob,
  fileName: string,
  download?: boolean
) => {
  const url = window.URL.createObjectURL(blobData)
  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  if (download) {
    a.download = fileName
  }
  a.click()
}

export function downloadFromBlobUrl(blobUrl: string, fileName?: string) {
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = fileName || 'file.xlsx'
  link.click()
  // (Опционально) Освобождаем память через несколько секунд
  setTimeout(() => URL.revokeObjectURL(blobUrl), 5000)
}
